import { useApiDocumentsV1DocumentsContextUrlRetrieve } from 'api';
import { dayjs } from 'date';
import { useTranslation } from 'i18n';
import { BackButton, Box, Link, Stack, Typography, TypographyIcon } from 'ui';
import { AccessTimeOutlined, CheckCircleOutlined } from 'ui/icons';

import { DOCUMENT_TYPE_DISPLAYED_VALUE } from '../../../document/utils/document';
import { useDocument } from '../../context/DocumentContext';

export const Header = () => {
  const { t } = useTranslation('orders');
  const { document } = useDocument();
  const { data: contextUrl } = useApiDocumentsV1DocumentsContextUrlRetrieve(document.id);

  const lastEditedAt = dayjs(document.updated_at).format('YYYY.MM.DD');

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        gap: 1.5,
        marginBottom: 1.25,
        mt: 1.5,
        mx: 3,
      }}
    >
      {window.history.length > 1 ? <BackButton onClick={() => window.history.back()} /> : null}
      <Stack
        useFlexGap
        direction="column"
        sx={{
          gap: 1,
        }}
      >
        <Typography fontWeight="bold">
          {t('documentGeneration.documentDetails.header.reviewFor', {
            values: {
              documentType: DOCUMENT_TYPE_DISPLAYED_VALUE[document.document_type],
            },
          })}
          {contextUrl?.url ? (
            <Link href={contextUrl.url}>
              {' '}
              {document.context_model_name} #{document.context_object_id}
            </Link>
          ) : (
            <Typography>
              {document.context_model_name} #{document.context_object_id}
            </Typography>
          )}
        </Typography>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 1.5,
          }}
        >
          <Typography color="secondary">
            {t('documentGeneration.documentDetails.header.lastEditedOn', { values: { date: lastEditedAt } })}
          </Typography>
          {document.fully_signed ? (
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <TypographyIcon icon={CheckCircleOutlined} color="secondary">
                {t('documentGeneration.documentDetails.header.signed')}
              </TypographyIcon>
            </Box>
          ) : (
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <TypographyIcon color="secondary" icon={AccessTimeOutlined}>
                {t('documentGeneration.documentDetails.header.signaturePending')}
              </TypographyIcon>
            </Box>
          )}
          {document.last_sent_at ? (
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <TypographyIcon color="secondary" icon={AccessTimeOutlined}>
                {t('documentGeneration.documentDetails.header.sentOn', {
                  values: { date: dayjs(document.last_sent_at).format('YYYY.MM.DD HH:mm') },
                })}
              </TypographyIcon>
            </Box>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
};
